import { type RankedOpen, useBestOpens } from "../../shared/bestOpens.js";

export interface RecentOpensContent {
  title: string;
  /** Most valuable first. `[]` renders nothing, and is all a signed-out visitor gets. */
  opens: RankedOpen[];
}

/** The home page's "Fire pulls": the shopper's best recent opens. */
export function useRecentOpensContent(): RecentOpensContent {
  return { title: "Fire pulls", opens: useBestOpens() };
}
